<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-30 16:55:22
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-02-27 11:01:14
-->
<template>
	<div class="sysgenImg">
		<div class="card pointer" v-loading="loading" element-loading-text="手卡生成中" element-loading-spinner="el-icon-loading" @click="showImgDialog">
			<img :src="imgUrl" alt="" ref="img" />
		</div>
		<div class="yx-color-primary reset pointer" @click="getImg()" v-if="error">生成失败，重新生成</div>
		<preview-pictures :src="imgUrl" v-if="dialogImgVisible" @close="dialogImgVisible = false" />
	</div>
</template>
<script>
import { previewHandcard } from '@/api/shopManage';
import previewPictures from '@/components/common/previewPictures';
export default {
	name: 'SysgenImg',
	components: {
		previewPictures,
	},
	data() {
		return {
			loading: false,
			error: false,
			imgUrl: '',
			dialogImgVisible: false,
			product_id: '',
		};
	},
	methods: {
		async getImg(val) {
			if (val) this.product_id = val;
			const { product_id } = this;
			this.loading = true;
			try {
				const data = await previewHandcard({ product_id });
				this.imgUrl = data.url;
				this.loading = false;
				this.$emit('succeedCard', this.imgUrl);
			} catch (error) {
				this.loading = false;
				this.error = true;
			}
		},
		showImgDialog() {
			this.dialogImgVisible = true;
		},
		clearFiles() {
			this.error = false;
			this.$refs.img.src = '';
			this.loading = false;
		},
	},
};
</script>

<style lang="less" scoped>
.sysgenImg {
	position: relative;
	margin: 24px 0 0 24px;
}

.card {
	width: 80px;
	height: 80px;
	border: dashed 1px #e3e3e3;
	border-radius: 5px;
	position: relative;
	img {
		width: 100%;
		height: 100%;
	}
}
.reset {
	position: absolute;
	top: 60px;
	left: 100px;
}
/deep/ .el-loading-spinner .el-loading-text {
	color: #000000 !important;
}
/deep/ .el-icon-loading:before {
	color: #000000 !important;
}
/deep/.el-dialog__header {
	border: none !important;
}
</style>
